import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import withApproveTermsGuard from "app/pages/sales-intelligence/sub-modules/contacts-search/hoc/withApproveTermsGuard";
import {
    selectIsContactsFullAccess,
    selectIsContactsPendingApproval,
    selectIsContactsReadonly,
} from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import RevealActionButton from "../../components/ContactsTableActionsPanel/RevealActionButton/RevealActionButton";
import { selectRemainingQuota } from "../../store/selectors";

type RevealActionButtonProps = {
    isLoading: boolean;
    numberOfResults: number;
    onClick: VoidFunction;
    onApprove?: () => Promise<unknown> | undefined;
};

const RevealActionButtonGuard = withApproveTermsGuard(RevealActionButton);

const ContactsRevealActionButtonContainer = ({
    isLoading,
    numberOfResults,
    onClick,
    onApprove,
}: RevealActionButtonProps): ReactElement => {
    const remainingRevealQuota = useSelector(selectRemainingQuota);
    const isContactsRevealAccess = useSelector(selectIsContactsFullAccess);
    const isContactReadonlyAccess = useSelector(selectIsContactsReadonly);
    const isContactsPendingApproval = useSelector(selectIsContactsPendingApproval);

    return (
        <RevealActionButtonGuard
            remainingRevealQuota={remainingRevealQuota}
            areSearchResultsFetching={isLoading}
            numberOfResults={numberOfResults}
            isContactsRevealAccess={isContactsRevealAccess}
            isContactReadonlyAccess={isContactReadonlyAccess || isContactsPendingApproval}
            onClick={onClick}
            onApprove={onApprove}
        />
    );
};

export default ContactsRevealActionButtonContainer;
